import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  notification: {}
};

//Handles the incoming actions.
export default handleActions({}, INITIAL_STATE);
